import { Component, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { fabric } from 'fabric';
import { OnDynamicData } from 'ngx-dynamic-hooks';
import { BehaviorSubject, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FabricWindowControls } from '../../../../utils/fabric-utils/fabric-window-controls';
import { ManipulativeChildObject } from '../../../models/manipulative-child-object.model';
import { IQuestionEventsService, QUESTION_EVENTS_SERVICE_TOKEN } from '../../../../services/IQuestionEvents';
import { Inject } from '@angular/core';


@UntilDestroy()
@Component({
  selector: 'backward',
  template: '',
  styleUrls: [],
  standalone: false
})
export class BackwardComponent extends ManipulativeChildObject {
  public isLoaded = new BehaviorSubject(false);
  private control!: FabricWindowControls;

  public order = 0;

  @Input() public frame = '';
  @Input() public img = '';

  public onChange = new Subject<number>();
  
  public constructor( @Inject(QUESTION_EVENTS_SERVICE_TOKEN) public readonly questionEventsService: IQuestionEventsService){
    super();
  }

  public click(): void {
    this.questionEventsService.controlClicked.next(true);    
    this.onChange.next(-1);
  }

  public override onDynamicMount(data: OnDynamicData): void {
    super.onDynamicMount(data);
    this.control = new FabricWindowControls({
      frame: this.frame.replace(/'/g, '').split(',')
        .map(Number),
      img: this.img.replace(/'/g, '')
    });

    this.control.on('mouseup', () => this.click());

    this.control.loaded$.pipe(
      tap(loaded => this.isLoaded.next(loaded)),
      untilDestroyed(this)
    ).subscribe()
  }

  public get fabricObject(): fabric.Object[] {
    return [this.control];
  }

  public ngOnDestroy(): void {
    if (this.questionEventsService.controlClicked) {
     this.questionEventsService.controlClicked.next(false);
    }
  }
}
